import { convertFromRaw, EditorState } from "draft-js";

import createEditorWithDecorators from "editor/utils/createEditorWithDecorators";
import { editorDecorators } from "editor/decorators";

/**
 * Given a raw API response of raw draft state, return an EditorState
 * @param {object} rawState - Raw Draft state.
 * @param {array} blocks.blocks - The blocks of the raw state
 * @param {array} blocks.entityMap - The entities of the raw state
 */
const getHydratedDraftInstance = rawState => {
  if (rawState.blocks.length > 0) {
    const contentState = convertFromRaw(rawState);
    return createEditorWithDecorators(contentState);
  }

  return EditorState.createEmpty(editorDecorators);
};

export default getHydratedDraftInstance;
